import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import * as mobx from 'mobx'
import { inject, observer } from "mobx-react";
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import plimage from '../../../../../../../assets/img/sonic-pricing-table.png';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = theme => ({
  root: {
    minHeight: 400,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2
  },
  campaignCard:{
    marginBottom: theme.spacing.unit * 2,
    backgroundColor:'black',
  },
  subtitle: {
    marginTop: theme.spacing.unit
  },
  divider:{
    marginTop: theme.spacing.unit,
  },
  plimage: {
    width: '100%',
    padding: theme.spacing.unit * 2,
  },
})

@inject("commonStore")
@observer
class FixedCampaign extends Component {
  state = {
    open: false,
  };
  handleChange = (name, item) => {
    const { updateFixed } = this.props
    const { filters: rawFilters } = item
    const filters = mobx.toJS(rawFilters)

    console.log('FixedCampaign handleChange')
    console.log(filters)

    updateFixed({fixedCampaignName: name, filters})
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  makeDialog = () => {
    const { open } = this.state
    const { classes } = this.props
    return <Dialog
  //  fullScreen
    maxWidth={'lg'}
    open={open}
    onClose={this.handleClose}
    TransitionComponent={Transition}
  >
  <DialogTitle id="alert-dialog-slide-title">
       {'Price Levels'}
  </DialogTitle>

    <DialogContent>
    <Typography>Please reference the table below to understand how Sonic Leads are scored according to their reported income level x household size (FPL%). Lead routing is based on your active campaign specifications, and all fulfillment is final. A comprehensive lead list can be found in the Leads tab of your dashboard.</Typography>
    <Grid 
    container
    spacing={24}>

      <Grid item xs={12}>
        <Paper className={classes.paper}>    
        <Typography variant="headline" color="textSecondary">Leads Categorized by Federal Poverty Level </Typography>
        <img src={plimage} className={classes.plimage}/>
        </Paper>
      </Grid>
    </Grid>
    </DialogContent>
    <DialogActions>
    <Button onClick={this.handleClose} color="primary">
      Close
    </Button>
  </DialogActions>

  </Dialog>

  }
  makeItemList = () => {
      console.log(this.props)
      const { commonStore, classes, fixedCampaignName, campaignID } = this.props
      const { network } = commonStore
      const { priceMaps } = network
      const { fixed: fixedMaps} = priceMaps
      
      const keys = Object.keys(fixedMaps)
      
      const filteredKeys = keys.filter((key) => {
          return fixedMaps[key].active === true
      })

      const arrayOfFixed = filteredKeys.map((key) => {
        const newItem = {...fixedMaps[key], key }
        return newItem
      }).sort((a, b) => parseFloat(a.row) - parseFloat(b.row));

  

      return arrayOfFixed.map((item) => {
       // console.log('filteredKeys: ' + key)
        const { active, title, description, discount, inclusions, price, key } = item
        //title
        //description
        //price
        return (
          <Card key={title} className={classes.campaignCard}>
          <CardContent>
        <Grid container alignItems="center">
        <Grid item xs={5}>
        <FormControlLabel
        control={
              <Checkbox
                disabled={campaignID}
                checked={key === fixedCampaignName}
                onChange={() => {this.handleChange(key, item)}}
                value={key}
                color="primary"
              />
            }
              label={ 
               <Typography variant="h6" color="inherit" >
                  {title}
              </Typography>}
            />
        </Grid>
        <Grid item xs={6}>
        <Typography variant="h6" color="inherit" >
                  {description}
              </Typography>
        </Grid>
        <Grid item xs={1}>
        <Typography variant="h6" color="inherit" >
              {`$${price / 100}`}
              </Typography>
        </Grid>
      </Grid>

      </CardContent>
          </Card>)

        return (
          <Card key={title} className={classes.campaignCard}>
          <CardContent>

          <Grid item xs={12}>
          <Grid
            container
            spacing={16}
            className={classes.agreement}
            alignItems={'center'}
            direction={'row'}
            justify={'space-between'}
          >
         
          <Grid item >
            <FormControlLabel

            control={
              <Checkbox
                disabled={campaignID}
                checked={key === fixedCampaignName}
                onChange={() => {this.handleChange(key, item)}}
                value={key}
                color="primary"
              />
            }
              label={ 
               <Typography variant="h6" color="inherit" >
                  {title}
              </Typography>}
            />
          </Grid>
          <Grid item >
              <Typography variant="h6" color="inherit" >
                  {description}
              </Typography>
          </Grid>
          <Grid item >
          <Typography variant="h6" color="inherit" >
              {`$${price / 100}`}
              </Typography>
          </Grid>
          </Grid>
        </Grid>
         
     

          </CardContent>
          </Card>
    )
    })  
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
      <Paper className={classes.root}>
      <Typography className={classes.subtitle} variant="h5">Real-Time Special Offers (Ages 18-62)</Typography>
      <Button className={classes.title} color="primary" onClick={this.handleClickOpen}>
        Click To View Poverty Level Descriptions
      </Button>
      <Divider className={classes.divider} />
      {this.makeItemList()} 
      </Paper>
      {this.makeDialog()}
      </div>
    );
  }
}

FixedCampaign.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FixedCampaign);




// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Fixed/index.js